document.addEventListener('DOMContentLoaded', function () {
	var SEL_TAB_PAGE = '.with-nav-js';
	var tabPages = document.querySelectorAll(SEL_TAB_PAGE);

	for (var i = 0; i < tabPages.length; i += 1) {
		assignEventListener(tabPages[i]);
	}

	function assignEventListener(tabPage) {
		var tabs = tabPage.getElementsByClassName('entry-navigation')[0].getElementsByTagName('ul')[0].getElementsByTagName('li');
		var tabsS = tabPage.getElementsByClassName('tag')[0].getElementsByTagName('span');
		var pages = filterChild(tabPage, tabPage.querySelectorAll('.entry-article-block'));
		var links = filterChild(tabPage, tabPage.querySelectorAll('.stile'));

		for (var i = 0; i < tabs.length; i += 1) {
			var tab = tabs[i];
			var tabA = tab.getElementsByTagName('span')[0];

			tabA.addEventListener('click', (function (idx) {
				return function (e) {
					e.preventDefault();
					onTabClick(idx, tabsS, pages,links);
				};
			})(i));
		}

		onTabClick(0, tabsS, pages,links);
	}

	function filterChild(parent, nodeList) {
		return [].slice.call(nodeList).filter(function (x) {return x.parentNode === parent;});
	}

	function onTabClick(idx, tabs, pages, links) {
		for (var i = 0; i < tabs.length; i += 1) {
			if (i === idx) tabs[i].classList.add('current');
			else tabs[i].classList.remove('current');
		}
		for (var i = 0; i < pages.length; i += 1) {
			if (i === idx) pages[i].classList.add('current');
			else pages[i].classList.remove('current');
		}
		for (var i = 0; i < links.length; i += 1) {
			if (i === idx) links[i].classList.add('current');
			else links[i].classList.remove('current');
		}
	}

});
